import { Helmet } from "react-helmet-async";
import { PageLayout } from "@/components/layout/PageLayout";
import { CTABanner } from "@/components/ui/CTABanner";
import { useLanguage } from "@/contexts/LanguageContext";
import HeroSection from "@/components/ui/HeroSection";
import SMMSection from "@/components/ui/SMMSection";
import MarketResearchSection from "@/components/ui/MarketResearchSection";
import BudgetRequestSection from "@/components/ui/BudgetRequestSection";
import SystemsSection from "@/components/ui/SystemsSection";
import AutomationSection from "@/components/ui/AutomationSection";
import BISection from "@/components/ui/BISection";
import CustomSolutionsSection from "@/components/ui/CustomSolutionsSection";
import AboutCompanySection from "@/components/ui/AboutCompanySection";
import PrinciplesSection from "@/components/ui/PrinciplesSection";
import TestimonialsSection from "@/components/ui/TestimonialsSection";

const Index = () => {
  const { t } = useLanguage();

  return (
    <PageLayout
      seoTitle="Binar+ — цифровая трансформация бизнеса в Узбекистане"
      seoContent={`Binar+ — это консалтинговая компания, специализирующаяся на цифровой трансформации бизнеса в Узбекистане. Мы помогаем компаниям внедрять современные технологии для увеличения продаж, оптимизации процессов и масштабирования бизнеса. Наши услуги охватывают маркетинг, автоматизацию и разработку IT-решений.

SMM-продвижение в Узбекистане — это эффективный инструмент привлечения клиентов через социальные сети. Мы предоставляем услуги SMM-маркетинга в Ташкенте и по всему Узбекистану: ведение Instagram, Facebook, Telegram, настройка таргетированной рекламы и создание контента. Профессиональный SMM помогает бизнесу получать стабильный поток заявок и повышать узнаваемость бренда.

Маркетинговые исследования в Узбекистане позволяют принимать обоснованные бизнес-решения на основе данных. Мы проводим анализ целевой аудитории, конкурентный анализ, оценку ёмкости рынка и изучение потребительского поведения. Результаты исследований помогают оптимизировать маркетинговую стратегию и снизить риски при запуске новых продуктов.

Внедрение CRM-систем в Узбекистане систематизирует работу с клиентами и увеличивает продажи. Мы внедряем Bitrix24, amoCRM и другие CRM-платформы, настраиваем воронки продаж, интегрируем телефонию и обучаем персонал. CRM-система обеспечивает контроль за менеджерами и прозрачность всех этапов сделки.

Автоматизация бизнес-процессов в Узбекистане освобождает сотрудников от рутинных задач. Мы внедряем RPA-роботов, AI-агентов и интеллектуальные системы документооборота. Автоматизация снижает издержки, ускоряет обработку данных и минимизирует человеческий фактор.

BI-дашборды и бизнес-аналитика в Узбекистане превращают данные в actionable-insights. Мы разрабатываем интерактивные дашборды на Power BI и Tableau, интегрируем данные из CRM, ERP, 1С и других систем. Руководители получают реальную картину бизнеса для принятия стратегических решений.

Разработка программного обеспечения на заказ в Узбекистане включает создание веб-приложений, мобильных приложений для iOS и Android, скоринговых систем и интеграционных решений. Мы разрабатываем кастомные IT-решения под уникальные требования бизнеса.

Binar+ — часть финтех-группы с опытом работы на рынках ЕС и СНГ. Мы реализовали более 50 высоконагруженных проектов и гарантируем результат. Обратитесь к нам для бесплатной консультации по цифровой трансформации вашего бизнеса в Узбекистане.`}
    >
      <Helmet>
        <title>Binar+ | Digital Business Transformation Consulting</title>
        <meta
          name="description"
          content="Binar+ helps businesses transform digitally through strategic marketing, CRM implementation, process automation, and custom solutions."
        />
      </Helmet>

      {/* Hero Section with Parallax and 3D */}
      <HeroSection />

      {/* SMM Section with Parallax */}
      <SMMSection />

      {/* Market Research Section with Parallax */}
      <MarketResearchSection />

      {/* Budget Request Section */}
      <BudgetRequestSection />

      {/* Systems Implementation Section */}
      <SystemsSection />

      {/* Automation Section */}
      <AutomationSection />

      {/* BI Dashboards Section */}
      <BISection />

      {/* Custom Solutions Section */}
      <CustomSolutionsSection />

      {/* About Company Section */}
      <AboutCompanySection />

      {/* Testimonials Section */}
      <TestimonialsSection />

      {/* Principles Section */}
      <PrinciplesSection />
    </PageLayout>
  );
};

export default Index;
